/* eslint import/prefer-default-export: off */
/* eslint no-unused-vars: off */

export const enum sessionStorageVariables {
  userEmail = 'userEmail',
}

export const enum DateDisplayFormats {
  DayMonthYear = 'DD/MM/YYYY',
  MonthDayYear = 'MM/DD/YYYY',
  YearMonthDate = 'YYYY/DD/MM',
}

export const ValueConstants = {
  MaxQDModelTitleLength: 45,
  MaxQDModelDescriptionLength: 200,
};

export const enum WorkerActions {
  counterStart = 'counter-start',
  counterEnd = 'counter-end',
  counterReset = 'counter-reset',
  counterResetWithLogicStart = 'counter-reset-with-logic-start',
  counterResetWithLogicEnd = 'counter-reset-with-logic-end',
  timeoutComponentCountdown = 'timeout-component-countdown',
  timeoutComponentIntervalValue = 'timeout-component-interval-value',
  timeoutComponentCountdownIntervalClear = 'timeout-component-countdown-interval-clear',
}

export const enum RequestContext {
  LoanGuarantor = '3',
  Borrower = '2',
  Guarantor = '1',
  Loan = '0'
}

export const enum ListItemNames {
  PortalApplicationStatus = 'PortalApplicationStatus'
}

export const enum CacheOptionCategories {
  ListItems = 'ListItems',
}

export const enum ApplicationStatuses {
  Started = 'Started',
  Approved = 'Approved',
  Denied = 'Denied',
  OnHold = 'OnHold',
  Accepted = 'Accepted',
  WaitingOnCoApplicant = 'WaitingOnCoApplicant',
  ClosedExpired = 'ClosedExpired',
  ApprovedExpired = 'ApprovedExpired',
  ClosedAnnul = 'ClosedAnnul',
  Submitted = 'Submitted',
  HoldRemoved = 'HoldRemoved',
  ApprovedWithdrawn = 'ApprovedWithdrawn',
  ClosedWithdrawn = 'ClosedWithdrawn'
}

export const enum QDPartyStatuses {
  Pending = '0',
  Stopped = '1',
  Accepted = '2',
  DataGathered = '3',
  Authenticated = '4',
  FailedAuthentication = '5',
  Submitted = '6',
  Declined = '7',
  DeclarationsGathered = '8',
  NonCompliant = '9'
}

export const PasswordProtectedStatus = 'PasswordProtected';
